/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import * as wjCore from "@grapecity/wijmo"
// import * as wjGrid from "@grapecity/wijmo.grid"
// import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
// import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
// import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import ZyomuinKyuyoService from "../../../service/driverpayroll/zyomuinKyuyo/zyomuinKyuyoService"

import { TApiResponse } from "../../../service/TApiResponse"

import {
  TZyomuinKyuyoInfoGetRes,
  // TZyomuinKyuyoRegisterPutReq,
} from "../../../service/driverpayroll/zyomuinKyuyo/TZyomuinKyuyo"

/**
 * 乗務員給与調整入力
 * @returns
 */
const ZyomuinKyuyoRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [社員コード, set社員コード] = useState<string>("")
  const [社員氏名, set社員氏名] = useState<string>("")

  const [出勤, set出勤] = useState<number>(0)
  const [休出, set休出] = useState<number>(0)
  const [臨休, set臨休] = useState<number>(0)
  const [
    有休,
    //  set有休
  ] = useState<number>(0)
  const [売上額, set売上額] = useState<number>(0)
  const [走行キロ, set走行キロ] = useState<number>(0)
  const [有料額, set有料額] = useState<number>(0)
  const [稼働手当, set稼働手当] = useState<number>(0)
  const [稼働調整, set稼働調整] = useState<number>(0)
  const [稼働合計, set稼働合計] = useState<number>(0)
  const [支給合計, set支給合計] = useState<number>(0)
  const [基本給, set基本給] = useState<number>(0)
  const [有休補償, set有休補償] = useState<number>(0)
  const [時間外残業, set時間外残業] = useState<number>(0)
  const [深夜残業他, set深夜残業他] = useState<number>(0)
  const [休日手当, set休日手当] = useState<number>(0)
  const [地域調整手当, set地域調整手当] = useState<number>(0)
  const [通勤費, set通勤費] = useState<number>(0)
  const [旅費, set旅費] = useState<number>(0)
  const [住宅手当, set住宅手当] = useState<number>(0)
  const [能力開発, set能力開発] = useState<number>(0)
  const [業務手当他, set業務手当他] = useState<number>(0)
  const [評価割増, set評価割増] = useState<number>(0)

  const [労働時間, set労働時間] = useState<number>(0)
  const [待機時間, set待機時間] = useState<number>(0)
  const [残業, set残業] = useState<number>(0)
  const [深夜残業, set深夜残業] = useState<number>(0)
  const [休日残業, set休日残業] = useState<number>(0)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [method]
  /**
   * 検索
   */
  const search = async (id: string) => {
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new ZyomuinKyuyoService()

      const res = (await service.get(
        id
      )) as TApiResponse<TZyomuinKyuyoInfoGetRes>

      if (res.data) {
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)

        // set出勤(res.data.勤務数)
        // set休出(res.data.出勤日数_休出)
        // set臨休(res.data.休暇_臨休)
        // set有休(res.data.休暇_有休)
        // set売上額(res.data.乗務員売上)
        // set走行キロ(res.data.走行キロ)
        // set有料額(res.data.有料額)
        // set稼働手当(res.data.稼働手当)
        // set稼働調整(res.data.稼働調整)
        // set稼働合計(res.data.稼働合計)
        // set支給合計(res.data.給与明細_支給合計)
        // set基本給(res.data.給与明細_基本給)
        // set有休補償(res.data.給与明細_有休補償)
        // set時間外残業(res.data.給与明細_時間外残業)
        // set深夜残業他(res.data.給与明細_深夜残業他)
        // set休日手当(res.data.給与明細_休日手当)
        // set地域調整手当(res.data.給与明細_地域調整手当)
        // set通勤費(res.data.給与明細_通勤費)
        // set旅費(res.data.給与明細_旅費)
        // set住宅手当(res.data.給与明細_住宅手当)
        // set能力開発(res.data.給与明細_能力開発)
        // set業務手当他(res.data.給与明細_業務手当他)
        // set評価割増(res.data.給与明細_評価割増)

        // set労働時間(res.data.労働時間)
        // set待機時間(res.data.待機時間)
        // set残業(res.data.残業)
        // set深夜残業(res.data.深夜残業)
        // set休日残業(res.data.休日残業)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装

    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (稼働調整 == null) return

      // const service = new ZyomuinKyuyoService()
      // let res: TApiResponse<boolean>

      // 更新のみ
      // res = await service.put(createPutZyomuinKyuyo())

      // if (res) {
      //   isPrompt.current = false
      //   history.goBack()
      //   showInfoToast(`乗務員給与調整入力の更新が完了しました`)
      // }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    search(id).finally(() => {
      disPatch(画面ロック解除())
    })
    // ファイルロード後、戻るボタン押下時に警告が出るように変更
    isPrompt.current = true
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">乗務員固定費一覧</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 社員 */}
                  <MasterRegisterFormRow label="社員コード" isRequired={false}>
                    <div className="w-6rem">
                      <TextInput
                        id="社員コード"
                        name="社員コード"
                        value={社員コード}
                        setValue={set社員コード}
                        maxLength={4}
                        isReadOnly
                        placeholder="社員コード"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 社員氏名 */}
                  <MasterRegisterFormRow
                    label="氏名（漢字）"
                    isRequired={false}>
                    <div className="w-15rem">
                      <TextInput
                        id="社員氏名"
                        name="社員氏名"
                        value={社員氏名}
                        setValue={set社員氏名}
                        maxLength={100}
                        isReadOnly
                        placeholder="氏名"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  <br></br>
                  {/* 出勤 */}
                  <MasterRegisterFormRow label="出勤" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="出勤"
                      name="出勤"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={出勤}
                      setValue={(v) => {
                        set出勤(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休出 */}
                  <MasterRegisterFormRow label="休出" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="休出"
                      name="休出"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={休出}
                      setValue={(v) => {
                        set休出(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 臨休 */}
                  <MasterRegisterFormRow label="臨休" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="臨休"
                      name="臨休"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={臨休}
                      setValue={(v) => {
                        set臨休(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 有休 */}{" "}
                  <MasterRegisterFormRow label="有休" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="有休"
                      name="有休"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={有休}
                      setValue={(v) => {
                        set出勤(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 売上額 */}{" "}
                  <MasterRegisterFormRow label="売上額" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="売上額"
                      name="売上額"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={売上額}
                      setValue={(v) => {
                        set売上額(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 走行キロ */}{" "}
                  <MasterRegisterFormRow label="走行キロ" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="走行キロ"
                      name="走行キロ"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={走行キロ}
                      setValue={(v) => {
                        set走行キロ(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 有料額 */}{" "}
                  <MasterRegisterFormRow label="有料額" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="有料額"
                      name="有料額"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={有料額}
                      setValue={(v) => {
                        set有料額(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 稼働手当 */}{" "}
                  <MasterRegisterFormRow label="稼働手当" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="稼働手当"
                      name="稼働手当"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={稼働手当}
                      setValue={(v) => {
                        set稼働手当(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 稼働調整 */}{" "}
                  <MasterRegisterFormRow label="稼働調整" isRequired={true}>
                    <NumberInput
                      style={{ width: "6rem" }}
                      id="稼働調整"
                      name="稼働調整"
                      decimalPoint={0}
                      isFloat={true}
                      value={稼働調整}
                      setValue={(v) => {
                        set稼働調整(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 稼働合計 */}{" "}
                  <MasterRegisterFormRow label="稼働合計" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="稼働合計"
                      name="稼働合計"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={稼働合計}
                      setValue={(v) => {
                        set稼働合計(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 支給合計 */}{" "}
                  <MasterRegisterFormRow label="支給合計" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="支給合計"
                      name="支給合計"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={支給合計}
                      setValue={(v) => {
                        set支給合計(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 基本給 */}
                  <MasterRegisterFormRow label="基本給" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="基本給"
                      name="基本給"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={基本給}
                      setValue={(v) => {
                        set基本給(Math.floor(v))
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 有休補償 */}{" "}
                  <MasterRegisterFormRow label="有休補償" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="有休補償"
                      name="有休補償"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={有休補償}
                      setValue={(v) => {
                        set有休補償(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 時間外残業 */}{" "}
                  <MasterRegisterFormRow label="時間外残業" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="時間外残業"
                      name="時間外残業"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={時間外残業}
                      setValue={(v) => {
                        set時間外残業(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 深夜残業他 */}{" "}
                  <MasterRegisterFormRow label="深夜残業他" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="深夜残業他"
                      name="深夜残業他"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={深夜残業他}
                      setValue={(v) => {
                        set深夜残業他(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休日手当 */}{" "}
                  <MasterRegisterFormRow label="休日手当" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="休日手当"
                      name="休日手当"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={休日手当}
                      setValue={(v) => {
                        set休日手当(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 地域調整手当 */}{" "}
                  <MasterRegisterFormRow
                    label="地域調整手当"
                    isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="地域調整手当"
                      name="地域調整手当"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={地域調整手当}
                      setValue={(v) => {
                        set地域調整手当(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 通勤費 */}{" "}
                  <MasterRegisterFormRow label="通勤費" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="通勤費"
                      name="通勤費"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={通勤費}
                      setValue={(v) => {
                        set通勤費(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 旅費 */}{" "}
                  <MasterRegisterFormRow label="旅費" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="旅費"
                      name="旅費"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={旅費}
                      setValue={(v) => {
                        set旅費(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 住宅手当 */}{" "}
                  <MasterRegisterFormRow label="住宅手当" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="住宅手当"
                      name="住宅手当"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={住宅手当}
                      setValue={(v) => {
                        set住宅手当(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 能力開発 */}{" "}
                  <MasterRegisterFormRow label="能力開発" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="能力開発"
                      name="能力開発"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={能力開発}
                      setValue={(v) => {
                        set能力開発(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 業務手当他 */}
                  <MasterRegisterFormRow label="業務手当他" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="業務手当他"
                      name="業務手当他"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={業務手当他}
                      setValue={(v) => {
                        set業務手当他(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 評価割増 */}{" "}
                  <MasterRegisterFormRow label="評価割増" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="評価割増"
                      name="評価割増"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={評価割増}
                      setValue={(v) => {
                        set評価割増(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  <br></br>
                  {/* 労働時間 */}
                  <MasterRegisterFormRow label="労働時間" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="労働時間"
                      name="労働時間"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={労働時間}
                      setValue={(v) => {
                        set労働時間(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 待機時間 */}
                  <MasterRegisterFormRow label="待機時間" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="待機時間"
                      name="待機時間"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={待機時間}
                      setValue={(v) => {
                        set待機時間(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 残業 */}
                  <MasterRegisterFormRow label="残業" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="残業"
                      name="残業"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={残業}
                      setValue={(v) => {
                        set残業(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 深夜残業 */}
                  <MasterRegisterFormRow label="深夜残業" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="深夜残業"
                      name="深夜残業"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={深夜残業}
                      setValue={(v) => {
                        set深夜残業(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                  {/* 休日残業 */}
                  <MasterRegisterFormRow label="休日残業" isRequired={false}>
                    <NumberInput
                      readOnly
                      style={{ width: "6rem" }}
                      id="休日残業"
                      name="休日残業"
                      min={0.009}
                      step={0.001}
                      isFloat={true}
                      value={休日残業}
                      setValue={(v) => {
                        set休日残業(v)
                      }}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {id ? `更新` : `登録`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
    </>
  )
}

export default ZyomuinKyuyoRegister
